import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookEventBffItem, type WebhookEventDetails, WebhookEventStatus } from 'webhooks/shared/entities'

import { useQueryRequest } from '~/ui/hooks/utils'

const PENDING_STATUS_POLLING_INTERVAL_MS = 5000

async function getWebhookEventDetails(paymentProfileId: string, eventId: string) {
  return httpClientVendasCoreBff<WebhookEventBffItem>({
    url: `/v1/payment-profile/${paymentProfileId}/webhooks/${eventId}`,
    method: 'GET'
  })
}

export function useGetWebhookEventDetails(paymentProfileId: string, eventId: string, options?: { enabled?: boolean }) {
  const { data: response, ...rest } = useQueryRequest<WebhookEventBffItem>(
    ['useGetWebhookEventDetails', paymentProfileId, eventId],
    () => getWebhookEventDetails(paymentProfileId, eventId),
    {
      enabled: Boolean(paymentProfileId) && Boolean(eventId) && (options?.enabled ?? true),
      refetchInterval: data =>
        data?.data?.status === WebhookEventStatus.PENDING ? PENDING_STATUS_POLLING_INTERVAL_MS : false
    }
  )

  const bffItem = response?.data

  const data: WebhookEventDetails | undefined = bffItem
    ? {
        id: bffItem.id ?? '',
        externalId: bffItem.externalId ?? '',
        event: bffItem.event ?? '',
        status: (bffItem.status ?? '') as WebhookEventStatus,
        origin: bffItem.origin ?? undefined,
        createdAt: bffItem.createdAt,
        attempts: String(bffItem.attempts),
        maxAttempts: String(bffItem.maxAttempts),
        nextAttempt: bffItem.nextAttempt ?? undefined,
        lastAttempt: bffItem.lastAttempt ?? '',
        eventName: bffItem.event ?? '',
        description: '',
        request: bffItem.request ?? '',
        responses: (bffItem.responses ?? []).map(r => ({
          raw: r.raw ?? undefined,
          statusCode: r.statusCode,
          success: Number(r.success),
          attempt: r.attempt,
          time: r.time,
          createdAt: r.createdAt
        }))
      }
    : undefined

  return { data, ...rest }
}
